import styled from "styled-components";

export const Wrapper = styled.div`

    display: flex;
    padding: 5px;
    font-weight: bold;
    text-align: center;
    align-items: center;
    justify-content: space-around;
    flex-direction: column;
    

`